// extracted by mini-css-extract-plugin
export default {"pokemon_card":"PokemonCard_pokemon_card__YnIDj"};